import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';

/**
 * NavbarItem - A className-based implementation that matches the Bulma NavbarItem
 * 
 * This component provides the same API as Bloomer's NavbarItem for easy migration
 */
const NavbarItem = ({
  children,
  className,
  hasDropdown,
  isHoverable,
  isActive,
  isTab,
  hasDropdownUp,
  href,
  to,
  tag,
  ...rest
}) => {
  const navbarItemClasses = classNames('navbar-item', {
    'has-dropdown': hasDropdown,
    'is-hoverable': isHoverable,
    'is-active': isActive,
    'is-tab': isTab,
    'has-dropdown-up': hasDropdownUp,
    [className]: className,
  });

  // Handle different tag types (NavLink, a, etc.)
  if (tag === NavLink && to) {
    return (
      <NavLink
        to={to}
        className={navbarItemClasses}
        {...rest}
      >
        {children}
      </NavLink>
    );
  }

  if (tag === 'a' || href) {
    return (
      <a
        href={href || '#'}
        className={navbarItemClasses}
        {...rest}
      >
        {children}
      </a>
    );
  }

  // Default case - render as a div
  return (
    <div
      className={navbarItemClasses}
      {...rest}
    >
      {children}
    </div>
  );
};

NavbarItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  hasDropdown: PropTypes.bool,
  isHoverable: PropTypes.bool,
  isActive: PropTypes.bool,
  isTab: PropTypes.bool,
  hasDropdownUp: PropTypes.bool,
  href: PropTypes.string,
  to: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

NavbarItem.defaultProps = {
  children: null,
  className: '',
  hasDropdown: false,
  isHoverable: false,
  isActive: false,
  isTab: false,
  hasDropdownUp: false,
  href: '',
  to: '',
  tag: null,
};

export default NavbarItem;
